import { createSelector } from 'reselect';
import { armyListUnitSelectedElement } from '@Selectors/builder/myArmyList/common/constraints/elements/selectable/all-seleted-element';
import {
  getArmyList,
  getArmyListUnit,
  getUnits,
} from '@Selectors/builder/myArmyList/make/unit/edit/selector/editSelector';
import { SelectedElement } from '@Models';

export const armyListUnitSelectedElementsPresenter = createSelector(
  [getArmyList, getArmyListUnit, getUnits],
  (armyList, armyListUnit, units): SelectedElement[] => {
    if (!armyList || !armyListUnit) return [];

    return armyListUnitSelectedElement(armyList, armyListUnit, units);
  },
);
